export default __webpack_public_path__ + "static/media/Main-Layout-Header-Image-Mobile.74cb5550.png";